import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-grid-no-result',
  templateUrl: './grid-no-result.component.html',
  styleUrls: ['./grid-no-result.component.scss']
})
export class GridNoResultComponent implements OnInit {

  private defaultMessage = 'There is no data matching your search criteria';

  @Input()
  public loading = false;

  @Input()
  public count = 0;

  @Input()
  public message = this.defaultMessage;

  constructor() { }

  public ngOnInit() {
  }
}
